import * as React from "react";
import { WithStyles, withStyles, Theme, createStyles, Button } from "@material-ui/core";
import LoadingButton from "src/common/LoadingButton/LoadingButton";

interface ActionButtonsProps extends WithStyles<typeof styles> {
  disabled: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  className?: string;
  saveButtonText?: string;
  cancelButtonText?: string;
  children?: React.ReactNode;
}

class ActionButtons extends React.PureComponent<ActionButtonsProps> {
  render() {
    const { classes, disabled, onSubmit, onCancel, className, isSubmitting } = this.props;
    return (
      <div className={className}>
        <LoadingButton
          className={classes.button}
          disabled={disabled}
          isSubmitting={isSubmitting}
          variant="contained"
          color="secondary"
          onClick={onSubmit}
          classes={{}}
          title="Save Changes"
        >
          {this.props.saveButtonText ? this.props.saveButtonText : "Save"}
        </LoadingButton>
        <Button
          className={classes.button}
          disabled={disabled || isSubmitting}
          title="Cancel Changes"
          variant="outlined"
          color="default"
          onClick={onCancel}
        >
          {this.props.cancelButtonText ? this.props.cancelButtonText : "Cancel"}
        </Button>
        {!!this.props.children && <span className={classes.button}>{this.props.children}</span>}
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      margin: `${theme.spacing.unit}rem`,
      marginLeft: 0
    }
  });

export default withStyles(styles)(ActionButtons);
